import React, { useState } from "react";
import {
  logoColor,
  GraySmily,
  StepperBlue,
  StepperGray,
} from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import classes from "./Sidebar.module.css";

export default function Sidebar({
  parentStep,
  setParentStep,
  childStep,
  setChildStep,
}) {
  function OpenStep(e) {
    setParentStep(e);
    setChildStep(1);
  }
  function OpenChildStep(e) {
    setChildStep(e);
  }
  return (
    <>
      {/* Styles */}
      <style jsx>{`
        .${classes.stepCircleSelected1}::before {
          border-left: 1.5px solid ${Colors.mainBlue} !important;
        }
        .${classes.stepCircleSelected2}::after {
          border-left: 1.5px solid ${Colors.mainBlue} !important;
        }
        .${classes.stepCircleSelected2}::before {
          border-left: 1.5px solid ${Colors.mainBlue} !important;
        }
        .${classes.childSteps} li .${classes.stepCircle}::after {
          border-left-color: ${Colors.neutralShadesOfGainsboro} !important;
        }
        .${classes.childSteps} li .${classes.stepCircle}::before {
          border-left-color: ${Colors.neutralShadesOfGainsboro} !important;
        }
        // Step Label Color
        .${classes.stepLabel} {
          color: ${Colors.neutralShadesOfNero} !important;
        }
        .${classes.stepLabelSelected} {
          color: ${Colors.mainBlue} !important;
        }
      `}</style>
      <div
        className={`${[classes.sidebarContainer].join(" ")}`}
        style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}
      >
        <img src={logoColor} className={`${[classes.logo].join(" ")}`} />
        <h6
          className={`${[classes.heading]}`}
          style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}
        >
          Setup your account
        </h6>
        <ul className={`${[classes.stepsContainer].join(" ")}`}>
          {/* Step 1 */}
          <li>
            <div className={classes.stepWithTitle} onClick={() => OpenStep(1)}>
              <div
                className={classes.stepBox}
                style={
                  parentStep === 1
                    ? { backgroundColor: Colors.mainBlue, color: Colors.white }
                    : {
                      color: Colors.neutralShadesOfNero,
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }
                }
              >
                1
              </div>
              <p style={{ ...Fonts.h8, color: Colors.neutralShadesOfNero }}>
                Getting to know you
              </p>
            </div>
            {/* Opened Step 1*/}
            {parentStep === 1 && (
              <ul
                className={`${[
                  classes.childSteps,
                ].join(" ")}`}
              >
                <li
                  style={{ ...Fonts.p2 }}
                  className={`${[
                    childStep === 1 && classes.stepLabelSelected,
                  ].join(" ")}`}
                  onClick={() => OpenChildStep(1)}
                >
                  <div
                    className={`${[
                      classes.stepCircle,
                      childStep === 1
                        ? classes.stepCircleSelected1
                        : classes.stepCircleSelected2,
                    ].join(" ")}`}
                  >
                    <img src={childStep >= 1 ? StepperBlue : StepperGray} />
                  </div>
                  Personal info
                </li>
                <li
                  style={{ ...Fonts.p2 }}
                  className={`${[
                    childStep === 2 && classes.stepLabelSelected,
                  ].join(" ")}`}
                  onClick={() => OpenChildStep(2)}
                >
                  <div
                    className={`${[
                      classes.stepCircle,
                      childStep === 2 && classes.stepCircleSelected2,
                    ].join(" ")}`}
                  >
                    <img src={childStep === 2 ? StepperBlue : StepperGray} />
                  </div>
                  Background check
                </li>
              </ul>
            )}
          </li>

          {/* Step 2 */}
          <li>
            <div className={classes.stepWithTitle} onClick={() => OpenStep(2)}>
              <div
                className={classes.stepBox}
                style={
                  parentStep === 2
                    ? { backgroundColor: Colors.mainBlue, color: Colors.white }
                    : {
                      color: Colors.neutralShadesOfNero,
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }
                }
              >
                2
              </div>
              <p style={{ ...Fonts.h8, color: Colors.neutralShadesOfNero }}>
                Lesson details
              </p>
            </div>
            {/* Opened Step 2*/}
            {parentStep === 2 && (
              <ul
                className={` ${[
                  classes.childSteps,
                ].join(" ")}`}
              >
                <li
                  style={{ ...Fonts.p2 }}
                  className={`${[
                    childStep === 1 && classes.stepLabelSelected,
                  ].join(" ")}`}
                  onClick={() => OpenChildStep(1)}
                >
                  <div
                    className={`${[
                      classes.stepCircle,
                      childStep === 1 && classes.stepCircleSelected1,
                      childStep >= 2 && classes.stepCircleSelected2,
                    ].join(" ")}`}
                  >
                    <img src={childStep >= 1 ? StepperBlue : StepperGray} />
                  </div>
                  Set Lesson
                </li>
                <li
                  style={{ ...Fonts.p2 }}
                  className={`${[
                    childStep === 2 && classes.stepLabelSelected,
                  ].join(" ")}`}
                  onClick={() => OpenChildStep(2)}
                >
                  <div
                    className={`${[
                      classes.stepCircle,
                      childStep === 2 && classes.stepCircleSelected1,
                      childStep >= 3 && classes.stepCircleSelected2,
                    ].join(" ")}`}
                  >
                    <img src={childStep >= 2 ? StepperBlue : StepperGray} />
                  </div>
                  Address
                </li>
                <li
                  style={{ ...Fonts.p2 }}
                  className={`${[
                    childStep === 3 && classes.stepLabelSelected,
                  ].join(" ")}`}
                  onClick={() => OpenChildStep(3)}
                >
                  <div
                    className={`${[
                      classes.stepCircle,
                      childStep === 3 && classes.stepCircleSelected1,
                      childStep >= 4 && classes.stepCircleSelected2,
                    ].join(" ")}`}
                  >
                    <img src={childStep >= 3 ? StepperBlue : StepperGray} />
                  </div>
                  FAQ
                </li>
                <li
                  style={{ ...Fonts.p2 }}
                  className={`${[
                    childStep === 4 && classes.stepLabelSelected,
                  ].join(" ")}`}
                  onClick={() => OpenChildStep(4)}
                >
                  <div
                    className={`${[
                      classes.stepCircle,
                      childStep === 4 && classes.stepCircleSelected1,
                      childStep >= 5 && classes.stepCircleSelected2,
                    ].join(" ")}`}
                  >
                    <img src={childStep >= 4 ? StepperBlue : StepperGray} />
                  </div>
                  Price
                </li>
              </ul>
            )}
          </li>

          {/* Step 3 */}
          <li>
            <div className={classes.stepWithTitle} onClick={() => OpenStep(3)}>
              <div
                className={classes.stepBox}
                style={
                  parentStep === 3
                    ? { backgroundColor: Colors.mainBlue, color: Colors.white }
                    : {
                      color: Colors.neutralShadesOfNero,
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }
                }
              >
                3
              </div>{" "}
              <p style={{ ...Fonts.h8, color: Colors.neutralShadesOfNero }}>
                Set your schedule
              </p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}
